import { createMessenger } from '@userlike/messenger';

$(() => {
  async function createApi() {
    const result = await createMessenger({
      version: 1,
      widgetKey: '6df4162b0cc942bcb554a89998390e6c2cfa286bcdc54249aded2bdc088299b7',
    });

    if (result.kind === 'error') throw new Error(result.error);

    const { api } = result.value;

    if (api === null) {
      throw new Error('api reached end-of-life, please check documentation and upgrade.');
    }
    return api;
  }

  const name = $('[data-userlike-name]').attr('data-userlike-name');
  const email = $('[data-userlike-email]').attr('data-userlike-email');
  if (name && email) {
    const customData = {
      name,
      email,
    };
    const customer = $('[data-userlike-customer]') && $('[data-userlike-customer]').attr('data-userlike-customer');
    const company = $('[data-userlike-company]') && $('[data-userlike-company]').attr('data-userlike-company');

    const userlike = createApi();
    userlike.then(messenger => messenger.mount().then(() => {
      messenger.setContactInfo({
        name,
        email,
        company,
        external_customer_id: customer,
      }).then(() => messenger.setCustomData(customData));
    }));
  }
});
